import { ref } from 'vue';
import Request from '@/services/request';
import { EARLY_SETTLEMENT_HISTORY } from '@/utils/enum/endpoints';

const Req = new Request();

export default function useEarlySettlementHistory() {
  const data = ref([]);
  const error = ref(null);
  const isLoading = ref(false);
  const totalPages = ref(1);
  const totalItems = ref(0);

  const fetchData = async ({ page = 1, itemsPerPage = 10, status = null, sort = null } = {}) => {
    isLoading.value = true;
    try {
      const params = { page, itemsPerPage };
      if (status) params.status = status;
      if (sort) params.sort = sort;

      const response = await Req.get(EARLY_SETTLEMENT_HISTORY, params, {
        baseURL: '/sellerofficeapi/rest',
        headers: { Accept: 'application/json' },
      });

      if (response.status === 200) {
        const body = response.data || {};
        const paging = body.pagingModel || {};
        data.value = Array.isArray(body.items) ? body.items : [];
        totalItems.value = paging.totalCount ?? data.value.length;
        totalPages.value = paging.pageCount ?? (Math.ceil(totalItems.value / itemsPerPage) || 1);
        error.value = null;
      } else {
        throw new Error('Network response was not OK');
      }
    } catch (err) {
      error.value = err || null;
      data.value = [];
      totalPages.value = 1;
      totalItems.value = 0;
    } finally {
      isLoading.value = false;
    }
  };

  return {
    data,
    error,
    isLoading,
    totalPages,
    totalItems,
    fetchData,
  };
}


